import { DeviceDesktopSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const DeviceDesktopIcon = makeIcon(
  DeviceDesktopSvgIcon,
  'DeviceDesktopIcon',
)`
  position: relative;
  top: 0.1em;

  g {
    stroke: currentColor;
  }
`;
